exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#bg{\n    /*background-image: url(\"https://cdn.pixabay.com/photo/2020/03/08/23/23/coronavirus-4914026_960_720.jpg\");*/\n    background-image: url(\"https://cdn.pixabay.com/photo/2015/12/08/01/04/bookshelf-1082309_960_720.jpg\");\n    /*background-image: url(\"https://cdn.pixabay.com/photo/2015/06/08/15/11/typewriter-801921_960_720.jpg\");*/\n    /*background-image: url(\"https://cdn.pixabay.com/photo/2015/11/19/21/10/knowledge-1052010_960_720.jpg\");*/\n    background-position: center;\n    background-size: cover;\n}\n", ""]);

// exports
